import React from 'react';
import {
	Box,
	Stack
} from '@mui/material';
import Title from './Title';
import useMdUpScreen from '../hooks/useMdUpScreen';

function BigTitle({ text, hidden = false, textSx={}, containerSx={}, bar=true, paper=false }) {
  	const mdUpScreen = useMdUpScreen();
	return !hidden && (
		<Stack direction="row" display="flex" sx={{ padding: 1, ...containerSx }} boxShadow={paper ? 4 : 0}>
            {bar &&(<Box sx={{ backgroundColor: 'primary.main', height: '8px', width:  mdUpScreen ? '64px' : '32px', m: 'auto', ml: mdUpScreen ? '72px' : 1 }}/>)}
            <Title sx={{ color: "surfaces.medium", fontSize: '35px', fontWeight: 700, flex: 1, p: mdUpScreen ? 3 : 1, ...textSx }}>
                {text}
            </Title>
            {bar &&(<Box sx={{ backgroundColor: 'primary.main', height: '8px', width: mdUpScreen ? '64px' : '32px', m: 'auto', mr: mdUpScreen ? '72px' : 1}}/>)}
        </Stack>
	);
}

export default BigTitle;
